import type { TaskResponse } from "../tasks/TaskResponse"

export type APIResponse = TaskResponse
